import { z } from 'zod';
export const SummarizeCommitInput = z.object({
    repoId: z.string().min(1),
    sha: z.string().min(7),
});
export const SummarizeRangeInput = z.object({
    repoId: z.string().min(1),
    fromSha: z.string().min(7),
    toSha: z.string().min(7),
});
export const SummaryResponse = z.object({
    summary: z.string(),
    model: z.string(),
    cached: z.boolean(),
});
export const SummarizedShasResponse = z.object({
    shas: z.array(z.string()),
});
export const AiHistoryEntry = z.object({
    type: z.enum(['commit', 'range']),
    sha: z.string(),
    model: z.string(),
    inputTokens: z.number(),
    outputTokens: z.number(),
    // null quand ce modèle n'a pas d'entrée dans AiModelPricing au moment de la lecture — même
    // sémantique que AiUsageStats.estimatedCostUsd, mais par ligne : un modèle sans prix connu ne
    // doit pas empêcher d'afficher le coût des autres lignes de l'historique.
    costUsd: z.number().nullable(),
    rangeCommitCount: z.number().optional(),
    createdAt: z.string(),
});
export const AiHistoryResponse = z.object({
    entries: z.array(AiHistoryEntry),
    page: z.number(),
    totalPages: z.number(),
    totalCount: z.number(),
});
export const AiUsageStats = z.object({
    inputTokens: z.number(),
    outputTokens: z.number(),
    callCount: z.number(),
    // null quand CLAUDE_MODEL n'a pas d'entrée dans AiModelPricing (table de prix alimentée
    // manuellement) — un coût inconnu plutôt qu'un chiffre calculé avec un prix obsolète/absent.
    estimatedCostUsd: z.number().nullable(),
    model: z.string(),
    maxDiffChars: z.number(),
    dailyTokenQuota: z.number(),
    remainingTokensToday: z.number(),
});
export const AiModelPricingEntry = z.object({
    modelId: z.string(),
    inputPerToken: z.number(),
    outputPerToken: z.number(),
    updatedAt: z.string(),
});
export const AiPricingResponse = z.object({
    entries: z.array(AiModelPricingEntry),
    currentModel: z.string(),
});
export const UpdateAiModelPricingInput = z.object({
    inputPerToken: z.number().nonnegative(),
    outputPerToken: z.number().nonnegative(),
});
//# sourceMappingURL=ai.js.map